export default __webpack_public_path__ + "static/Artificial_Light_Indoor_5120kbps-a1ce31cbf97d90d792dfbcca50374b2b.avif";